import netflix from "../assets/netflix.png";
import netflixBg from "../assets/netflixBg.jpg";
import user1 from "../assets/user1.png";
import user2 from "../assets/user2.png";
import user3 from "../assets/user3.png";
import user4 from "../assets/user4.png";

export default {
  netflix,
  user1,
  user2,
  user3,
  user4,
  netflixBg,
};
